import React, { useContext } from "react";
import { Box, Container, Typography, Stack, Link } from "@mui/material";
import { LEGAL_ROUTE, RULES, USER_CABINET_ROUTE } from "../utils/consts";
import { useNavigate } from "react-router-dom";
import { Context } from "../index";
import { observer } from "mobx-react-lite";

const Footer = observer(() => {
    const {user} = useContext(Context);
    const navigate = useNavigate();

    return (
        <Box
            component="footer"
            sx={{
                mt: "auto",
                py: 3,
                backgroundColor: "background.paper",
                borderTop: "1px solid rgba(255,255,255,0.08)"
            }}
        >
            <Container maxWidth="xl">
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    justifyContent="space-between"
                    alignItems={{ xs: "flex-start", md: "center" }}
                >
                    <Typography variant="body2" color="text.secondary">
                        © 2023 - {new Date().getFullYear()} Scraplands. Все права защищены.
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Build {process.env.REACT_APP_VERSION}
                    </Typography>

                    <Stack
                        direction={{ xs: "column", md: "row" }}
                        spacing={{ xs: 1, md: 2 }}
                        alignItems="flex-start"
                    >
                        <Typography
                            noWrap
                            component="a"
                            sx={{ cursor: 'pointer'}}
                            onClick={() => {navigate(RULES);}}
                            underline="hover" color="text.secondary">
                            Правила
                        </Typography>
                        <Typography
                            noWrap
                            component="a"
                            sx={{ cursor: 'pointer'}}
                            onClick={() => {navigate(LEGAL_ROUTE);}}
                            underline="hover" color="text.secondary">
                            Оферта и Политика конфиденциальности
                        </Typography>
                        <Link
                            href="https://t.me/overlive_ru"
                            target="_blank"
                            underline="none"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                transition: "all 0.2s ease-in-out",
                                "& svg path": { fill: "#e1e1e1" }, // черно-белая иконка
                                "&:hover svg path": { fill: "#0088cc" } // цвет при hover
                            }}
                        >
                            <Box component="span" sx={{ mr: 1, display: "flex" }}>
                                {/* Telegram SVG */}
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 240 240"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M120 0C53.7 0 0 53.7 0 120s53.7 120 120 120 120-53.7 120-120S186.3 0 120 0zm55.1 81.5l-22.8 107.2c-1.7 7.7-6.2 9.6-12.6 5.9l-34.8-25.7-16.8 16.2c-1.8 1.8-3.3 3.3-6.1 3.3l2.2-31.3 57.1-51.6c2.5-2.2-0.6-3.5-3.8-1.3l-70.5 44.3-30.3-9.5c-6.6-2.1-6.7-6.6 1.4-9.8l118-45.5c5.5-2.1 10.3 1.3 8.8 9.3z" />
                                </svg>
                            </Box>
                            <Typography color="text.secondary">
                                Telegram
                            </Typography>
                        </Link>
                        {user && user.userInfo && user.userInfo.login && (
                            <Typography
                                noWrap
                                component="a"
                                sx={{ cursor: 'pointer'}}
                                onClick={() => {navigate(USER_CABINET_ROUTE);}}
                                      underline="hover" color="text.secondary">
                                Личный кабинет
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
});

export default Footer;